import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  changelog: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      entries: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  )
};

export default class Changelog extends PureComponent {
  render() {
    const { changelog } = this.props;

    return (
      <div>
        {changelog.map((item, i) => (
          <div key={`change-${i}`}>
            <p><strong>{item.title}</strong> <i>{item.date}</i></p>
            <ul>
              {item.entries.map((entry, index) => <li key={`change-entry-${index}`}>{entry}</li>)}
            </ul>
          </div>
        ))}
      </div>
    );
  }
}

Changelog.propTypes = propTypes;
